import { Pipe, PipeTransform } from '@angular/core';
import { blank, data_nullify } from '../shared/utils/common';

@Pipe({
  name: 'fallback',
  pure: false,
})
export class FallbackPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (blank(value)) {
      return data_nullify(args[0]);
    }

    return value;
  }
}